import { useState } from "react";
import { twMerge } from "tailwind-merge";

import { SectionHeader } from "~/common/components/ui";
import {
  PREVIEW_TITLE_CODES,
  previewSectionCodeToLabel,
} from "~/providers/constants/SummariesExpandableIds";
import {
  DIRECT_TO_INDIRECT_TO_SWATCH_MAP,
  getPreviewFunctionalDomainsIcon,
} from "~/providers/utils/getPreviewFunctionalDomainsIcon";
import {
  FUNCTIONAL_DOMAIN_KEY,
  FUNCTIONAl_DOMAINS_KEY_OPTIONS,
  FunctionalDomainsV2 as FunctionalDomainsV2Type,
} from "~/providers/utils/types/patientIntakePreviewTypes";
import Expandable from "../common/Expandable";
import { Inquiries } from "../v2/functionalDomains/Inquiries/Inquiries";
import { FunctionalDomainsModalV4 } from "./FunctionalDomainsModalV4";
import { FunctionalDomainsTitleV4 } from "./FunctionalDomainsTitleV4";

export const FunctionalDomainsV4 = ({
  functionalDomains,
}: {
  functionalDomains: FunctionalDomainsV2Type[];
}) => {
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  return (
    <>
      <FunctionalDomainsModalV4
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
      />
      <Expandable.Wrapper
        title={
          <FunctionalDomainsTitleV4 onClick={() => setShowInfoModal(true)} />
        }
        code={PREVIEW_TITLE_CODES.FUNCTIONAL_DOMAINS}
        className="gap-0 p-0"
        expandableSections={[...FUNCTIONAl_DOMAINS_KEY_OPTIONS]}
      >
        {functionalDomains.map(
          (
            {
              direct_inquiry,
              indirect_inquiry,
              may_indicate,
              narrative,
              section,
            },
            index,
          ) => (
            <Expandable.Section
              key={FUNCTIONAL_DOMAIN_KEY[section]}
              className={twMerge(
                "p-3",
                index === functionalDomains.length - 1 && "border-none",
              )}
              code={FUNCTIONAL_DOMAIN_KEY[section]}
              icon={getPreviewFunctionalDomainsIcon(
                direct_inquiry.classification,
                indirect_inquiry.classification,
                section,
              )}
              title={
                <div className="text-left">
                  <p
                    className="-mt-0.5 flex-1 text-left text-xs font-semibold first-letter:capitalize"
                    style={{
                      color:
                        DIRECT_TO_INDIRECT_TO_SWATCH_MAP[
                          direct_inquiry.classification
                        ][indirect_inquiry.classification].primary,
                    }}
                  >
                    {may_indicate}
                  </p>
                  <div className="flex">
                    <SectionHeader className="text-lg font-semibold leading-none first-letter:uppercase">
                      {
                        previewSectionCodeToLabel[
                          FUNCTIONAL_DOMAIN_KEY[section]
                        ]
                      }
                    </SectionHeader>
                  </div>
                  {narrative && (
                    <p className="mt-1 text-sm first-letter:capitalize">
                      {narrative}
                    </p>
                  )}
                </div>
              }
            >
              <Inquiries
                directInquiry={direct_inquiry}
                indirectInquiry={indirect_inquiry}
              />
            </Expandable.Section>
          ),
        )}
      </Expandable.Wrapper>
    </>
  );
};
